import { mapActions } from 'vuex';
import { formMixin, validators } from '@/components/forms/mixin';

export default {
  mixins: [
    formMixin,
  ],
  props: {
    token: {
      type: String,
    },
  },
  validations: {
    fields: {
      email: validators.email,
      newPassword: validators.password,
      newPasswordConfirmation: validators.passwordConfirmation('newPassword'),
    },
  },
  data() {
    return {
      fields: {
        email: '',
        newPassword: null,
        newPasswordConfirmation: null,
      },
    };
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('user', ['resetPassword']),
    ...mapActions('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']),
    onSubmit() {
      if (this.formIsValid() && this.formDisable()) {
        this.resetPassword({
          email: this.fields.email,
          password: this.fields.newPassword,
          token: this.token,
        })
        .then(() => {
          this.setCurrentPopup();
          this.$router.push({ name: 'home' });
          this.setSuccessSideNotification('Your password has been changed');
        })
        .catch((errors) => {
          this.formEnable();
          this.setErrorSideNotification(errors.response.data.message);
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-reset-password/account-reset-password.js